import { Route } from 'react-router-dom';
import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { LoadableForgotPassword } from '../../Pages/Auth/ForgotPassword/LoadableForgotPassword';
import { LoadableLogin } from '../../Pages/Auth/Login/LoadableLogin';
import { LoadableResetPassword } from '../../Pages/Auth/Reset/LoadableResetPassword';

const getLoginRoute = (props: object): AppRouteType => ({
    id: AppRoutes.LOGIN,
    render: Route,
    props: {
        exact: true,
        path: AppRoutes.LOGIN,
        component: LoadableLogin,
        ...props,
    },
});

const getForgotPasswordRoute = (props: object): AppRouteType => ({
    id: AppRoutes.PASSWORD_FORGOT,
    render: Route,
    props: {
        exact: true,
        path: AppRoutes.PASSWORD_FORGOT,
        component: LoadableForgotPassword,
        ...props,
    },
});

const getResetPasswordRoute = (props: object): AppRouteType => ({
    id: AppRoutes.PASSWORD_RESET,
    render: Route,
    props: {
        exact: true,
        path: AppRoutes.PASSWORD_RESET,
        component: LoadableResetPassword,
        ...props,
    },
});

export const getAuthRoutes = (args: object) => [
    getLoginRoute(args),
    getForgotPasswordRoute(args),
    getResetPasswordRoute(args),
];
